module.exports = __webpack_public_path__ + "static/media/logo-contabilidade1.fe0a4dba.png";